function update_final_price(){
  var $signet_options = $('.signet-opt-variants');
  if(!$signet_options.length) return;
  
  var $option_price = 0;
  var $product_price = $('.product__info-container .price-item--actual-price').data('price');
  $product_price = Number($product_price.replace(/[^0-9.-]+/g,""));

  var $face_shape_ip = $('.tee-field--template .tee-clipart.active input');
  var $personalization_ip = $(".personalization .tee-radio.active input");
  var $face_size_ip = $(".face-sizes .tee-radio.active input");

  if($face_shape_ip.length && $personalization_ip.length && $face_size_ip.length){
    var $face_shape = $face_shape_ip.parent().find('.tee-clipart-label__text').text();
    var $personalization_type = $personalization_ip.parent().find('label > span').text();

    var $face_size = $face_size_ip.parent().find('label > span').text()
    var $face_size_arr = $face_size.split(' ');
    $face_size = $face_size_arr[0]+'mm';
    if($face_size == '14X12mm'){
      if($face_shape == 'Oval'){
        $face_size = $face_size+'(Oval)';
      } else if($face_shape == 'Cushion'){
        $face_size = $face_size+'(Cushion)';
      } else if($face_shape == 'オーバル'){
        $face_size = $face_size+'(オーバル)';
      } else if($face_shape == 'クッション'){
        $face_size = $face_size+'(クッション)';
      }
    }

    var $search_option = $('.signet-opt-variant[data-title="'+ $personalization_type +' / '+ $face_size +'"]');
    if ($search_option.length && $search_option.data('price')) {
      var $option_price = $search_option.data('price');
      $option_price = $option_price.toString();
      $option_price = parseFloat($option_price.replace(',',''));
      if (!isNaN($option_price)) {
          if ($signet_options.data('currency') === 'GBP') {
              //$option_price = $option_price + ((20 / 100) * $option_price);
          }
      } else {
          $option_price = 0;
      }
    }
  }
    
  var $final_price = Math.round($product_price + $option_price);
  var $finalAmount = $final_price.toLocaleString($signet_options.data('locale'), {style: 'currency', currency: $signet_options.data('currency')});
  
  $('.product__info-container .price-item--regular-final').text( $finalAmount );
}

jQuery(function(){
  /* $(document).on("click",".personalization .tee-radio input,.tee-field--template .tee-clipart input,.ring-material .tee-clipart input,.face-sizes .tee-radio input",function() {
    setTimeout(function(){ _update_signet_variants(); },50); //variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
  }); */
  
  $(document).on("mousenter",".tee-field--template .tee-clipart input,.ring-material .tee-clipart input",function() {
    $(this).parent().find('label').trigger('mousenter');
  });

  var $option_price_w_cur = 0;
  $(document).on("click",".button-engraving",function() {

    if($('.has-engraving').hasClass('show-engraving')){
      $('.has-engraving').removeClass('show-engraving');
      $('#teeFormInputs .engraving-options .tee-radio:first-child label').trigger('click');
    } else {
      $('.has-engraving').addClass('show-engraving');
      $('#teeFormInputs .engraving-options .tee-radio:last-child label').trigger('click');
    }

    var $product_options = $('.signet-opt-variants');
    if(!$product_options.length) return;
    
    var $option_price = 0;
    var $product_price = $('.product__info-container .price-item--actual-price').data('price');
    if (typeof $product_price === 'string') {
        $product_price = Number($product_price.replace(/[^0-9.-]+/g, ""));
    } else {
        $product_price = Number($product_price); // Already a number
    }

    var $engraving_ip = $(".engraving-options .tee-radio input:checked");
    var $engraving = $engraving_ip.parent().find('label > span').text();
    if(shop_locale=='ja'){
      $engraving = '彫刻';
    }

    var $search_option = $('.signet-opt-variant[data-title="'+ $engraving +'"]');
    if ($search_option.length && $search_option.data('price')) {
      var $option_price = $search_option.data('price');
      $option_price = $option_price.toString();
      $option_price = parseFloat($option_price.replace(',',''));
      if (!isNaN($option_price)) {
        if ($product_options.data('currency') === 'GBP') {
          //$option_price = $option_price + ($option_price * 0.2);
        }
      } else {
          $option_price = 0;
      }
      $option_price = Math.round($option_price);
      $option_price_w_cur = $option_price.toLocaleString($product_options.data('locale'), {style: 'currency', currency: $product_options.data('currency'),minimumFractionDigits: 0,maximumFractionDigits: 0});
    }
    
    var $final_price = Math.round($product_price + $option_price);
    var $finalAmount = $final_price.toLocaleString($product_options.data('locale'), {style: 'currency', currency: $product_options.data('currency'),minimumFractionDigits: 0,maximumFractionDigits: 0});

    
    $('.product__info-container .price-item--regular-final').text( $finalAmount ).show();

    if(!$('.has-engraving').hasClass('show-engraving')){
      if(shop_locale == 'ja'){
        $(this).text('手彫りでパーソナライズ : ' + $option_price_w_cur);
      } else {
        $(this).text('Personalise with Hand Engraving : ' + $option_price_w_cur);
      }
    } else {
      if(shop_locale == 'ja'){
        $(this).text('彫刻を削除する');
      } else {
        $(this).text('Remove Engraving');
      }
    }
    
  });

  $(document).on("change",".button-cracker",function() {

    var $is_selected = $(this).is(':checked');

    if ($is_selected) {
      $('.has-cracker').addClass('show-cracker');
    } else {
      $('.has-cracker').removeClass('show-cracker');
    }

    $('#cracker_id').prop('disabled', !$is_selected);

    var $product_options = $('.cracker-opt-variants');
    var $offer = $('.cracker-offer');

    // Prefer the gift price rendered directly on the cracker offer card
    // (always present on any has_cracker_2026 product) over
    // .price-item--actual-price, which price.liquid only renders when the
    // engraving metafield is also active on the product.
    var $product_price = $offer.data('gift-price');
    if (typeof $product_price === 'undefined' || $product_price === '') {
      $product_price = $('.product__info-container .price-item--actual-price').data('price');
    }
    if (typeof $product_price === 'string') {
        $product_price = Number($product_price.replace(/[^0-9.-]+/g, ""));
    } else {
        $product_price = Number($product_price);
    }
    if (isNaN($product_price)) { $product_price = 0; }

    // Read the cracker add-on price straight off the offer card's own
    // data-cracker-price attribute (the same figure already shown as
    // "+£X" on the card), rather than hunting the hidden
    // .cracker-opt-variant input for one specifically titled "Purple" —
    // that only ever matches when the cracker product's one rendered
    // variant happens to be called Purple, so it silently priced the
    // add-on at £0 for every other cracker product/variant.
    var $option_price = $offer.data('cracker-price');
    if (typeof $option_price === 'string') {
      $option_price = parseFloat($option_price.replace(/,/g, ''));
    } else {
      $option_price = Number($option_price);
    }
    if (isNaN($option_price)) {
      $option_price = 0;
    }
    $option_price = Math.round($option_price);

    var $locale = $product_options.data('locale');
    var $currency = $product_options.data('currency');
    var $money_opts = {style: 'currency', currency: $currency, minimumFractionDigits: 0, maximumFractionDigits: 0};

    var $final_price = $is_selected ? Math.round($product_price + $option_price) : Math.round($product_price);
    var $finalAmount = $final_price.toLocaleString($locale, $money_opts);
    $('.product__info-container .price-item--regular-final').text( $finalAmount ).show();

    // Price breakdown row under the main buy button.
    $('.cracker-offer-summary__gift-amount').text( $product_price.toLocaleString($locale, $money_opts) );
    $('.cracker-offer-summary__cracker-amount').text( $option_price.toLocaleString($locale, $money_opts) );
    $('.cracker-offer-summary__total-amount').text( $finalAmount );
    $('.cracker-offer-summary').prop('hidden', !$is_selected);

    // Main "Add to Bag" button text, e.g. "Add Gift and Cracker to Bag".
    var $submit_text = $('.the-submit-button[data-type="atc-button"] > span').first();
    if ($is_selected && $submit_text.data('with-cracker-text')) {
      $submit_text.text( $submit_text.data('with-cracker-text') );
    } else if (!$is_selected && $submit_text.data('default-text')) {
      $submit_text.text( $submit_text.data('default-text') );
    }

  });



  
  onTeeFormInputsLoad();
  function onTeeFormInputsLoad(){
    if($('#teeFormInputs').length > 0 && !$('.has-engraving').hasClass('personalization-loaded')){
      $('.product__info-container .price__regular .price-item--regular').hide();
      $('.has-engraving').addClass('personalization-loaded');

      //$('#teeFormInputs .engraving-options').find('.tee-radio:first-child input').trigger('click');
      $('#teeFormInputs .engraving-options .tee-radio:first-child label').trigger('click');
      
    } else {
      setTimeout(function(){
        onTeeFormInputsLoad();
      },2000);
    }
  }

  function appendSelected($e,$t){
    var label = $e.parent().parent().parent().parent().parent().children('label');
    if(label.find('.selected-name').length == 0){
      label.append(' : <span class="selected-name"></span>')
    }
    label.find('.selected-name').text($t);
  }

  var $perz_type = ''
  var $material = '';
  var $face_size = '';
  var $ring_size = '';
  var $initials = '';

  var $face_size_org = '';

  var $p_perz_type = '';
  function _update_signet_variants(){
    //setDefaultSelected();
    
    if($perz_type!='')
      $p_perz_type = $perz_type;
    $(".personalization .tee-radio input").each(function(){
      //if($(this).is(":checked")){
      if($(this).parent().hasClass("active")){
        $perz_type = $(this).parent().find('label > span').text();
        if($perz_type == '無地'){
          $perz_type = 'Plain';
        } else if($perz_type == 'イニシャル'){
          $perz_type = 'Initials';
        } else if($perz_type == 'クレスト' || $perz_type == '紋章'){
          $perz_type = 'Crest';
        }

        
        if($('.signet_description.signet_desc_'+$perz_type+'.open').length == 0){
          $('.signet_description').removeClass('open').hide();
          $('.signet_description.signet_desc_'+$perz_type).addClass('open').show();
        }
      }      
    });
    
    var $face_shape = '';
    $(".tee-field--template .tee-clipart input").each(function(){
      if($(this).parent().hasClass("active")){
        $face_shape = $(this).parent().find('.tee-clipart-label__text').text();
        appendSelected($(this),$face_shape);
        
        $('input[name="Style"]').each(function(){
          var $sel_val = $(this).val();
          if($face_shape == $(this).val()){
            $(this).trigger('click');
          }
        });
      }
    });

    $(".ring-material .tee-clipart input").each(function(){
      if($(this).parent().hasClass("active")){
        $material = $(this).parent().find('.tee-clipart-label__text').text();
        appendSelected($(this),$material);
        $('input[name="Material"]').each(function(){
          if($material == $(this).val()){
            $(this).trigger('click');
          }
        });
      }
    });

    //set default face size if not set
    var $face_size_ip = $(".face-sizes .tee-radio input");
    if($(".face-sizes .tee-radio input:checked").length == 0){
      $(".face-sizes .tee-radio:first-child label").trigger('click');
    }

    $face_size_ip.each(function(){
      if($(this).parent().hasClass("active")){
        var $sel_value = $(this).parent().find('label > span').text()
        var $sel_value_arr = $sel_value.split(' ');
        $face_size = $sel_value_arr[0]+'mm';
        $face_size_org = $sel_value_arr[0];
        if($face_size == '14X12mm'){
          if($face_shape == 'Oval'){
            $face_size = $face_size+'(Oval)';
          } else if($face_shape == 'Cushion'){
            $face_size = $face_size+'(Cushion)';
          } else if($face_shape == 'オーバル'){
            $face_size = $face_size+'(オーバル)';
          } else if($face_shape == 'クッション'){
            $face_size = $face_size+'(クッション)';
          }
        }
        
        $('input[name="Face Size"]').each(function(){
          if($face_size == $(this).val()){
            $(this).trigger('click');
          }
        });
      }
    });

    $(".ring-sizes .tee-radio input").each(function(){
      //if($(this).is(":checked")){
      if($(this).parent().hasClass("active")){
        $ring_size = $(this).parent().find('label > span').text();
      }      
    });

    if($('.face-size-guide-btn').length && $('.face-sizes a').length == 0){
      $('.face-sizes').append( $('.face-size-guide-btn').html() )
    }
    //since Plain and Initials face size are most same, we should update final price when switching between them. 
    //Checking != Crest condition to avoid double update - when we switch from Crest to Plain/Intials we do not need to call this function
    //if( ($p_perz_type != 'Crest') && ($perz_type == 'Plain' || $perz_type == 'Initials') ){
      update_final_price();
    //}
    setTimeout(function(){ _update_signet_variants(); },1000);
  }

  $(document).on("click",".tee-field--template .tee-clipart,.tee-field--template .tee-clipart input,.tee-field--template .tee-clipart label",function(e) {
    e.stopPropagation();
    setDefaultSelected(".personalization .tee-radio input",$perz_type);
    setDefaultSelected(".ring-material .tee-clipart input",$material);
    setDefaultSelected(".face-sizes .tee-radio input",$face_size_org);
    setDefaultSelected(".ring-sizes .tee-radio input",$ring_size);
    updateInitials();
  });

  $(document).on("click",".personalization .tee-radio input",function() {
    setDefaultSelected(".ring-material .tee-clipart input",$material);
    setDefaultSelected(".face-sizes .tee-radio input",$face_size_org);
    updateInitials();
    update_final_price();
  });

  $(document).on("click",".ring-material .tee-clipart input",function() {
    setDefaultSelected(".face-sizes .tee-radio input",$face_size_org);
  });

  $(document).on("click",".ring-sizes .tee-radio input",function() {
    $ring_size = $(this).parent().find('label > span').text();
  });

  function updateInitials(){
    setTimeout(function(){
      if($('.initials-text').find('input').length && $initials!=''){
        $('.initials-text').find('input').val($initials);
      }
    },50);
  }
  
  function setDefaultSelected($e,$s){
    setTimeout(function(){
      if($s != ''){
        var $matched = false;
        $($e).each(function(){
          var $me = $(this);
          var $value = $(this).parent().find('label > span').text();
          if($me.is(":checked")==false && $value == $s){
            $me.trigger('click');
            $me.parent().find('label').trigger('click');
            $matched = true;
          }
        });
        if($matched == false){
          $($e).parent().parent().parent().addClass('active');
          $($e).parent().parent().parent().find('.tee-clipart-col:first-child label').trigger('click');
        }
      }
    },10);
  }

  function _initiateSignetVariants(){
    if($('.ring-material').length == 0){
      setTimeout(function(){
        _initiateSignetVariants();
      },2000);
    } else {
      setTimeout(function(){
        if($('.initials-text').find('input').length && $('.initials-text').find('input').val() != ''){
          $initials = $('.initials-text').find('input').val();
        }
        _update_signet_variants();
        update_final_price();
      },2000);
    }
  }
  _initiateSignetVariants();

  $('.tee-clipart .tee-checkbox-input').mouseenter(function() {
     $(this).parent().addClass('option-hovered');
  });
  $('.tee-clipart .tee-checkbox-input').mouseleave(function() {
    $(this).parent().removeClass('option-hovered');
  });
  
});

document.body.addEventListener('mouseenter', (event) => {
  if (event.target.matches('.tee-checkbox-input')) {
    const target = event.target.nextElementSibling;
    if (target != undefined) {
      const mouseEnterEvent = new Event('mouseenter');
      target.dispatchEvent(mouseEnterEvent);
    }
  }
}, true);

document.body.addEventListener('mouseleave', (event) => {
  if (event.target.matches('.tee-checkbox-input')) {
    const target = event.target.nextElementSibling;
    if (target != undefined) {
      const mouseLeaveEvent = new Event('mouseleave');
      target.dispatchEvent(mouseLeaveEvent);
    }
  }
}, true);

